import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes
} from "@fortawesome/free-solid-svg-icons";

export const AnchorTemporaryDrawer = (props) => {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => {
    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? '100%' : '100%' }}
      role="presentation"
    >
      <div className='toggleremovebuttoncontainer'><button className='toggleremovebutton' onClick={(e) => {
        toggleDrawer(anchor, false)
      }}><FontAwesomeIcon icon={faTimes} /></button></div>
      {props.children}
    </Box>
  );

  return (
    <div>
      {!props?.enableFileAnnotation && <button className={`${props?.customButtonClass!='' ? props?.customButtonClass : "btn btn-danger ms-2"}`} onClick={() => toggleDrawer(props.anchor, true)}>{props.buttonLabel}</button>}
      {(['left', 'right', 'top', 'bottom']).map((anchor) => (
        <React.Fragment key={anchor}>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            className='collection-toggle-viewer'
            onClose={() => toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
